<div class="formulario-contenido-menu" *ngIf="dentroDeMenu || visible">
  <div class="formulario-header">
    <h2>Subir Registro de Asistencia</h2>
    <p class="subtitulo">
      Cargue hasta tres respaldos digitales (asistencia, evidencia u otro documento) para esta actividad grupal.
    </p>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()" aria-label="Cerrar panel">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content">
    <div class="campos-archivos-asistencia">
      <div class="campo-archivo-asistencia" *ngFor="let slot of slots">
        <label class="etiqueta-archivo" [for]="idInputArchivo(slot.campo)">
          <ion-icon [name]="slot.icono" class="icono-etiqueta-archivo" aria-hidden="true"></ion-icon>
          {{ slot.etiqueta }}
        </label>

        <div class="archivo-existente-asistencia" *ngIf="slot.adjuntoExistente as adj">
          <span class="nombre-archivo-existente" [title]="adj.nombre_archivo">{{ adj.nombre_archivo }}</span>
          <ion-button
            fill="clear"
            size="small"
            class="btn-ver-archivo-asistencia"
            (click)="verArchivoExistente(slot)"
            [disabled]="accionesBloqueadas"
            title="Ver documento"
            [attr.aria-label]="'Ver documento ' + adj.nombre_archivo">
            <ion-icon slot="icon-only" name="eye-outline"></ion-icon>
          </ion-button>
          <ion-button
            fill="clear"
            size="small"
            color="danger"
            class="btn-eliminar-archivo-asistencia"
            (click)="eliminarArchivoExistente(slot)"
            [disabled]="accionesBloqueadas"
            title="Eliminar documento"
            [attr.aria-label]="'Eliminar ' + slot.etiqueta">
            <ion-spinner *ngIf="estaEliminando(slot.campo)" slot="icon-only" name="crescent" aria-hidden="true"></ion-spinner>
            <ion-icon *ngIf="!estaEliminando(slot.campo)" slot="icon-only" name="trash-outline" aria-hidden="true"></ion-icon>
          </ion-button>
        </div>

        <input
          #fileInput
          [id]="idInputArchivo(slot.campo)"
          type="file"
          class="file-input-oculto"
          [attr.accept]="fileAccept"
          (change)="onArchivoChange(slot.campo, $event)" />
        <button
          type="button"
          class="zona-carga-asistencia"
          [class.zona-cargando]="subiendo"
          (click)="activarSelectorArchivo(fileInput)"
          [disabled]="accionesBloqueadas"
          [attr.aria-busy]="subiendo"
          [attr.aria-label]="subiendo ? 'Subiendo archivo' : (slot.nombreArchivoMostrar || 'Seleccionar ' + slot.nombreCorto)">
          <ng-container *ngIf="subiendo; else contenidoZonaNormal">
            <ion-spinner name="crescent" class="spinner-zona-carga" aria-hidden="true"></ion-spinner>
            <span class="texto-principal">Subiendo archivo…</span>
            <span class="texto-hint" *ngIf="slot.nombreArchivoMostrar">{{ slot.nombreArchivoMostrar }}</span>
          </ng-container>
          <ng-template #contenidoZonaNormal>
            <ion-icon name="cloud-upload-outline" class="icono-carga" aria-hidden="true"></ion-icon>
            <span class="texto-principal">
              {{ slot.nombreArchivoMostrar || ('Seleccione ' + slot.nombreCorto) }}
            </span>
            <span class="texto-hint">PDF, JPG o PNG (Máx 5MB)</span>
          </ng-template>
        </button>
      </div>
    </div>
  </div>

  <div class="formulario-footer">
    <ion-button fill="outline" (click)="cerrar()" [disabled]="accionesBloqueadas">Cancelar</ion-button>
    <ion-button (click)="onSubirClick()" [disabled]="accionesBloqueadas || !hayArchivosPendientes">
      <ion-spinner *ngIf="subiendo" slot="start" name="crescent" aria-hidden="true"></ion-spinner>
      <ion-icon *ngIf="!subiendo" slot="start" name="cloud-upload-outline"></ion-icon>
      {{ textoBotonPrincipal }}
    </ion-button>
  </div>
</div>
